import { render } from "./colour-swatch.vue?vue&type=template&id=c78a0528"
import script from "./colour-swatch.vue?vue&type=script&lang=js"
export * from "./colour-swatch.vue?vue&type=script&lang=js"

import "./colour-swatch.vue?vue&type=style&index=0&id=c78a0528&lang=scss"

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__